import React, { type ReactElement } from 'react'
import { BlurryEffect } from '@/components'
import { Badge } from '@/components/ui/badge'

interface HomeHeroProps {
  title: string
  lead: string
  overline?: string
}

function HomeHero({ title, lead, overline }: Readonly<HomeHeroProps>): ReactElement | null {
  return (
    <section className="relative animate__animated animate__fadeIn">
      <div className="max-w-7xl mx-auto flex justify-center h-auto min-h-140">
        <div className="relative z-30 flex flex-col gap-8 items-center justify-center text-center w-full px-8 min-w-0">
          {overline ? <Badge>{overline}</Badge> : null}
          <h1 className="text-4xl md:text-6xl max-w-3xl font-extrabold animate__animated animate__fadeInUp">
            {title}
          </h1>
          <p className="text-base md:w-2/3 text-muted-foreground md:text-lg animate__animated animate__fadeInDown">
            {lead}
          </p>
        </div>
      </div>
      <figure className="absolute z-10 inset-0">
        <BlurryEffect />
      </figure>
    </section>
  )
}

export { HomeHero }
